(ns teamoesterreich.admin-mode.modal.create-with-name-modal
  (:require [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left  :refer [keyboard-arrow-left]]
            ))


(defn modal [!show message ok-message on-ok-fn &[on-cancel-fn default-name]]
  (let [!new-name (r/atom nil)]
    [mui/modal
     {
      :aria-labelledby "simple-modal-title"
      :aria-describedby "simple-modal-description"
      :style {:display "flex"
              :marginRight "auto"
              :marginLeft "auto"
              :alignItems "center"
              :justifyContent "center"}
      :open (or @!show false)

      }
     [:div
      {
       :class "modal"
       :style {:width 600}}
      [:h4  message]

      [mui/text-field
       {:onChange (fn [e] (reset! !new-name (h/event-value e)))
        :defaultValue (str default-name)
        :fullWidth true
        }]

      [:br]
      [:br]
      [mui/button
       {:color "primary"
        :variant "contained"
        :startIcon (r/as-element [keyboard-arrow-left])
        :style {:marginRight 50}
        :onClick (fn []
                   (if on-cancel-fn
                     (on-cancel-fn)
                     (reset! !show false)))
        }
       "Abbrechen"]
      [mui/button
       {:style {:float "right" }
        :variant "contained"
        :startIcon (r/as-element [done])
        :onClick (fn []
                   (on-ok-fn @!new-name)
                   (reset! !show false))
        }
       ok-message]]
     ]
    ))


